import sunnyvaleImg from "./Assets/images/sunnyvale.jpg";
import sanFranciscoImg from "./Assets/images/san-francisco.jpg";
import sanJoseSignNight from "./Assets/images/san-jose-sign-night.jpg";
import sanJoseBuild1 from "./Assets/images/san-jose-build-1.jpg";
import sanJoseBuild2 from "./Assets/images/san-jose-build-2.jpg";
import sanJoseBuild3 from "./Assets/images/san-jose-build-3.jpg";
import sanJoseBuild4 from "./Assets/images/san-jose-build-4.jpg";

export type LocationHours = {
  day: string;
  hours: string;
  closed?: boolean;
};

export type LocationId = "sunnyvale" | "san-francisco" | "san-jose";

export type RestaurantLocation = {
  id: LocationId;
  name: string;
  service: string;
  address: string;
  hoursSummary: string;
  hours: LocationHours[];
  mapEmbed?: string;
  mapsLink?: string;
  orderUrl?: string;
  statusPage?: string;
  comingSoon?: boolean;
  image: string;
  imageAlt: string;
  imagePosition?: string;
  gallery?: { src: string; alt: string }[];
};

export type OrderableLocation = RestaurantLocation & { orderUrl: string };

export const PHONE_DISPLAY = "(669) 777-3303";
export const PHONE_HREF = "tel:+16697773303";
export const EMAIL = "bagarasca@gmail.com";

export const locations: RestaurantLocation[] = [
  {
    id: "sunnyvale",
    name: "Sunnyvale",
    service: "Dine-in, takeout & delivery",
    address: "594 E El Camino Real, Sunnyvale, CA 94087",
    hoursSummary:
      "Mon–Thu 10:00 AM–2:30 PM & 5:30–10:00 PM · Fri 10:00 AM–2:30 PM & 5:30–11:45 PM · Sat 11:00 AM–2:30 PM & 5:30–11:45 PM · Sun 11:00 AM–2:30 PM & 5:30–10:00 PM",
    hours: [
      { day: "Monday", hours: "10:00 AM–2:30 PM, 5:30–10:00 PM" },
      { day: "Tuesday", hours: "10:00 AM–2:30 PM, 5:30–10:00 PM" },
      { day: "Wednesday", hours: "10:00 AM–2:30 PM, 5:30–10:00 PM" },
      { day: "Thursday", hours: "10:00 AM–2:30 PM, 5:30–10:00 PM" },
      { day: "Friday", hours: "10:00 AM–2:30 PM, 5:30–11:45 PM" },
      { day: "Saturday", hours: "11:00 AM–2:30 PM, 5:30–11:45 PM" },
      { day: "Sunday", hours: "11:00 AM–2:30 PM, 5:30–10:00 PM" },
    ],
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6342.42621390708!2d-122.02603849999998!3d37.3611341!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb670b182dce1%3A0xe5beb593c8285a97!2s594%20E%20El%20Camino%20Real%2C%20Sunnyvale%2C%20CA%2094087!5e0!3m2!1sen!2sus!4v1728144817724!5m2!1sen!2sus",
    mapsLink: "https://maps.app.goo.gl/TX71JhDMXHc4dnvC7",
    orderUrl:
      "https://order.tryotter.com/s/bagara's/594-east-el-camino-real-sunnyvale/e7a016c9-c780-4075-8cca-58272d6e7887",
    image: sunnyvaleImg,
    imageAlt: "Bagara's storefront at 594 E El Camino Real in Sunnyvale",
    imagePosition: "center 35%",
  },
  {
    id: "san-francisco",
    name: "San Francisco",
    service: "Takeout & delivery",
    address: "90 Charter Oak Ave, San Francisco, CA 94124",
    hoursSummary: "Tue–Sun 10:00 AM–1:00 PM & 5:30–10:00 PM. Closed Monday.",
    hours: [
      { day: "Monday", hours: "Closed", closed: true },
      { day: "Tuesday", hours: "10:00 AM–1:00 PM, 5:30–10:00 PM" },
      { day: "Wednesday", hours: "10:00 AM–1:00 PM, 5:30–10:00 PM" },
      { day: "Thursday", hours: "10:00 AM–1:00 PM, 5:30–10:00 PM" },
      { day: "Friday", hours: "10:00 AM–1:00 PM, 5:30–10:00 PM" },
      { day: "Saturday", hours: "10:00 AM–1:00 PM, 5:30–10:00 PM" },
      { day: "Sunday", hours: "10:00 AM–1:00 PM, 5:30–10:00 PM" },
    ],
    mapEmbed:
      "https://maps.google.com/maps?q=90%20Charter%20Oak%20Ave%2C%20San%20Francisco%2C%20CA%2094124&z=15&output=embed",
    mapsLink:
      "https://www.google.com/maps/search/?api=1&query=90+Charter+Oak+Ave%2C+San+Francisco%2C+CA+94124",
    orderUrl:
      "https://order.tryotter.com/s/bagaras/90-charter-oak-ave%2C-san-francisco%2C-ca-94124%2C-usa-san-francisco/e54d4fb2-fc26-4949-b9af-f33b80165f2a",
    image: sanFranciscoImg,
    imageAlt: "Golden Gate Bridge in San Francisco at sunset",
  },
  {
    id: "san-jose",
    name: "San Jose",
    service: "Closed",
    address: "San Jose, CA",
    hoursSummary: "Closed · Permit pending",
    hours: [],
    statusPage: "/san-jose",
    comingSoon: true,
    image: sanJoseSignNight,
    imageAlt: "Bagara's San Jose night sign and dining room during construction",
    imagePosition: "center",
    gallery: [
      { src: sanJoseSignNight, alt: "Bagara's San Jose illuminated storefront sign at night" },
      { src: sanJoseBuild1, alt: "San Jose dining room and kitchen partition during construction" },
      { src: sanJoseBuild2, alt: "San Jose dining area with a table near the entry partition" },
      { src: sanJoseBuild3, alt: "San Jose tables facing the kitchen partition" },
      { src: sanJoseBuild4, alt: "San Jose dining room from the host stand" },
    ],
  },
];

export const isOrderable = (location: RestaurantLocation): location is OrderableLocation =>
  Boolean(location.orderUrl);

export const orderableLocations = locations.filter(isOrderable);

export const getLocation = (id: string | null) =>
  orderableLocations.find((location) => location.id === id);
